<!--INPUTS SET AS DEFAULT BUTTON-->
<div style="margin-top: 3%;">
  <app-result-set-config-btn *ngIf="inputsConf"
                             [resultSetConfig]="inputsConf"
                             (toggleChangeNotifier)="onResultSetDefaultChange(ResultSetIDEnum.SUMMARY_INPUTS)"
  >
  </app-result-set-config-btn>
</div><!--START SELECTION BOXES-->
<div class="row flex-row">
  <!-- Category Select -->
  <div class="flex-item">
    <mat-form-field floatLabel="never" class="anessa-dropdown">
      <mat-select
        id='baseline-summary-category_select'
        [(value)]="categorySet"
        disableOptionCentering
        (valueChange)="setTableData(); onDropdownChange(ResultSetIDEnum.SUMMARY_INPUTS)"
        panelClass="anessa-dropdown-panel">
        <mat-option
          *ngFor="let opt of categoriesOptions"
          [value]="opt">{{ opt | anessaTranslation: trigger }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <!-- Currency Select -->
  <div class="flex-item">
    <mat-form-field floatLabel="never" class="anessa-dropdown">
      <mat-select
        id='baseline-summary-currency_select'
        [(value)]="currencySet"
        placeholder="{{'RESULTS.GENERAL.SET_CURRENCY' | anessaTranslation: trigger}}"
        disableOptionCentering
        [disabled]="currencyOptions.length === 0"
        (valueChange)="setTableData(); onDropdownChange(ResultSetIDEnum.SUMMARY_INPUTS)"
        panelClass="anessa-dropdown-panel">
        <mat-option
          *ngFor="let opt of currencyOptions"
          [value]="opt">{{ opt.translationId | anessaTranslation: trigger }}
        </mat-option>
      </mat-select>
      <mat-label *ngIf="currencyOptions.length === 0">
        <div class="select-placeholder-container">
          <span>{{'RESULTS.SUMMARY.LOADING' | anessaTranslation: trigger}}</span>
          <mat-spinner class="spinner" diameter="20"></mat-spinner>
        </div>
      </mat-label>
    </mat-form-field>
  </div>
  <!-- Measurement System Select -->
  <div class="flex-item">
    <mat-form-field floatLabel="never" class="anessa-dropdown">
      <mat-select
        id='baseline-summary-measurement_select'
        [(value)]="measurementSet"
        placeholder="{{'RESULTS.GENERAL.SET_UNIT_TYPE' | anessaTranslation: trigger }}"
        disableOptionCentering
        (valueChange)="setTableData(); onDropdownChange(ResultSetIDEnum.SUMMARY_INPUTS)"
        panelClass="anessa-dropdown-panel">
        <mat-option
          *ngFor="let opt of measurementOptions"
          [value]="opt">{{ opt | anessaTranslation: trigger }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
<!--END SELECTION BOXES-->

<div>
  <p>{{'RESULTS.GENERAL.EXCHANGE_RATES_FROM' | anessaTranslation: trigger}} <i>{{ exchangeRateDate }}</i></p>
</div>

<!-- Inputs table -->
<results-treetable #inputsTreetable
  *ngIf="categorySet === 'RESULTS.SUMMARY.ALL' || categorySet ===  'RESULTS.SUMMARY.INPUTS'"
  [inputsData]="inputSummary"
  [firstColumnHeader]="'RESULTS.SUMMARY.INPUTS' | anessaTranslation: trigger"
  [hideSaveButtons]="true"
  [translateHeaders]="['RESULTS.DATA.UNIT']"
></results-treetable>

<div *ngIf="categorySet === 'RESULTS.SUMMARY.ALL' || categorySet ===  'RESULTS.SUMMARY.OUTPUTS'">
  <!--OUTPUTS SET AS DEFAULT BUTTON-->
  <div>
    <app-result-set-config-btn *ngIf="outputsConf"
                               [resultSetConfig]="outputsConf"
                               (toggleChangeNotifier)="onResultSetDefaultChange(ResultSetIDEnum.SUMMARY_OUTPUTS)"
    >
    </app-result-set-config-btn>
  </div>
  <!-- Period Select -->
  <div class="row flex-row">
    <div class="flex-item">
      <mat-form-field floatLabel="never" class="anessa-dropdown">
        <mat-select
          id="baseline-summary-period_select"
          [(value)]="periodSet"
          disableOptionCentering
          (valueChange)="this.outputsData = this.makeOutputs(); onDropdownChange(ResultSetIDEnum.SUMMARY_OUTPUTS)"
          panelClass="anessa-dropdown-panel">
          <mat-option
            *ngFor="let opt of periodOptions"
            [value]="opt">{{ opt | anessaTranslation: trigger }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <!-- Outputs table -->
  <results-treetable #outputsTreetable
    [resultsData]="outputsData"
    [firstColumnHeader]="'RESULTS.SUMMARY.OUTPUTS' | anessaTranslation: trigger"
    [hideSaveButtons]="true"
  ></results-treetable>
</div>

<!-- Cash flow graph -->
<div class="row flex-row" *ngIf="showCashFlowGraph() && this.csGraph.length > 0">
  <div class="flex-item">
    <app-graph-selector #cashFlowGraph
      [graphData]="csGraph"
      [currencyLabel]="currencySet ? currencySet.displayName : 'CAD'"
      [xAxisLabel]="'RESULTS.GENERAL.YEARS' | anessaTranslation: trigger"
      [graphType]="'raw'"
      [hideSaveButtons]="true"
    ></app-graph-selector>
  </div>
</div>

<app-flow-diagram-creator #pfdComponent
  [project]="projectState"
  [precision]="2"
  [periodType]="'day'"
  *ngIf="projectState && results"
  [results]="results"
  [updateGraphSignal]="pfdReload"
  [hideMeasurementSelect]="true"
  [hideSpacingSlider]="true"
  [hideSaveButtons]="true"
  [resultSetConf]="pfdConf"
  [resultSetConfUpdatedNotifier]="pfdConfUpdatedNotifier"
  (resultSetConfSaveNotifier)="onResultSetDefaultChange(ResultSetIDEnum.SUMMARY_PFD)"
></app-flow-diagram-creator>

<div class="results-container">
  <div class="item" >
    <button mat-button
            class="btn-green first-layer-button"
            (click)="saveToPdf()"
    >{{'RESULTS.SUMMARY.SAVE_TO_PDF' | anessaTranslation: trigger}}
    </button>
  </div>
  <div class="item">
    <button
      mat-button
      class="btn-green first-layer-button"
      (click)="saveToExcel()"
    >{{'RESULTS.SUMMARY.SAVE_TO_EXCEL' | anessaTranslation: trigger}}
    </button>
  </div>
</div>
